var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    className: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "account_circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 14.2A7.2 7.2 0 0 1 6 16c0-2 4-3.1 6-3.1s6 1 6 3a7.2 7.2 0 0 1-6 3.3z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "arrow_right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.7 15.3 2.6-2.6c.4-.4.4-1 0-1.4l-2.6-2.6a1 1 0 0 0-1.7.7v5.2a1 1 0 0 0 1.7.7z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "arrow_upward"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 19V7.8l4.9 5c.4.3 1 .3 1.4 0 .4-.5.4-1.1 0-1.5l-6.6-6.6a1 1 0 0 0-1.4 0l-6.6 6.6a1 1 0 1 0 1.4 1.4L11 7.8V19c0 .6.5 1 1 1s1-.5 1-1z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "build"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3C10 .8 7 .4 4.8 1.6l3.6 3.6c.4.4.4 1 0 1.4L6.7 8.3a1 1 0 0 1-1.4 0L1.7 4.7a6.5 6.5 0 0 0 8 8.9l8 8c1 1 2.7 1 3.8 0 1-1 1-2.8 0-3.8l-8-7.9c1-2.3.5-5.1-1.4-7z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "cancel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm4.3 14.3a1 1 0 0 1-1.4 0L12 13.4l-2.9 2.9a1 1 0 1 1-1.4-1.4l2.9-2.9-2.9-2.9a1 1 0 1 1 1.4-1.4l2.9 2.9 2.9-2.9a1 1 0 1 1 1.4 1.4L13.4 12l2.9 2.9c.4.4.4 1 0 1.4z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "dark_mode"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 3a9 9 0 1 0 10 10 1 1 0 0 0-1.6-1c-.8.6-1.8.9-2.9.9a5.4 5.4 0 0 1-4.6-8.3 1 1 0 0 0-.9-1.5z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "delete"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 19c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v10zM18 4h-2.5l-.7-.7A1 1 0 0 0 14 3H9.9a1 1 0 0 0-.7.3l-.7.7H6c-.6 0-1 .5-1 1s.5 1 1 1h12c.6 0 1-.5 1-1s-.5-1-1-1z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "error"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 11a1 1 0 0 1-1-1V8c0-.6.5-1 1-1s1 .5 1 1v4c0 .6-.5 1-1 1zm1 4h-2v-2h2v2z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "expand_less"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.3 8.7-4.6 4.6a1 1 0 1 0 1.4 1.4l3.9-3.9 3.9 4a1 1 0 1 0 1.4-1.5l-4.6-4.6a1 1 0 0 0-1.4 0z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "expand_more"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 24H0V0h24v24z",
    fill: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 9.3 12 13.2l-3.9-4a1 1 0 1 0-1.4 1.5l4.6 4.6c.4.4 1 .4 1.4 0l4.6-4.6c.4-.4.4-1 0-1.4a1 1 0 0 0-1.4 0z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "file_upload"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 10H9v5c0 .6.4 1 1 1h4c.5 0 1-.5 1-1v-5h1.6a1 1 0 0 0 .7-1.7l-4.6-4.6a1 1 0 0 0-1.4 0L6.7 8.3a1 1 0 0 0 .7 1.7zM5 19c0 .6.5 1 1 1h12c.6 0 1-.5 1-1s-.5-1-1-1H6a1 1 0 0 0-1 1z"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "gpp_maybe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.3 2.3-6 2.2A2 2 0 0 0 4 6.4V11c0 5 3.4 9.8 8 10.9 4.6-1.1 8-5.9 8-11V6.5a2 2 0 0 0-1.3-1.9l-6-2.2a2 2 0 0 0-1.4 0zM12 16a1 1 0 0 1-1-1c0-.6.5-1 1-1 .6 0 1 .5 1 1 0 .6-.4 1-1 1zm0-4a1 1 0 0 1-1-1V8c0-.6.5-1 1-1 .6 0 1 .5 1 1v3c0 .6-.4 1-1 1z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "group_add"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22 9V8c0-.6-.5-1-1-1a1 1 0 0 0-1 1v1h-1a1 1 0 0 0-1 1c0 .6.5 1 1 1h1v1c0 .6.5 1 1 1 .6 0 1-.5 1-1v-1h1c.6 0 1-.5 1-1 0-.6-.5-1-1-1h-1zM8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 13c-2.7 0-8 1.3-8 4v3h16v-3c0-2.7-5.3-4-8-4zM12.5 4a6 6 0 0 1 0 8 4 4 0 0 0 0-8zM16.5 13.8c1 .9 1.5 1.9 1.5 3.2v3h2v-3c0-1.4-1.6-2.5-3.5-3.2z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "group_remove"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10c0-.6.5-1 1-1h4c.6 0 1 .5 1 1s-.5 1-1 1h-4a1 1 0 0 1-1-1zM8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 9c-2.7 0-8 1.3-8 4v3h16v-3c0-2.7-5.3-4-8-4zm4.5-9a6 6 0 0 1 0 8 4 4 0 0 0 0-8zm4 9.8c1 .9 1.5 1.9 1.5 3.2v3h2v-3c0-1.4-1.6-2.5-3.5-3.2z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "help"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 17h-2v-2h2v2zm2-7.8-.8 1A3.5 3.5 0 0 0 13 15h-2v-.5a4 4 0 0 1 1.2-2.8l1.2-1.3a2 2 0 0 0 .6-1.8 2 2 0 0 0-1.4-1.5A2 2 0 0 0 10 8.3c-.1.4-.4.7-.8.7H9c-.6 0-1-.6-.8-1.1A4 4 0 0 1 11.4 5a4 4 0 0 1 3.9 1.8c1.1 1.7.8 3.4-.2 4.5z"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "home"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19v-5h4v5c0 .6.5 1 1 1h3c.6 0 1-.5 1-1v-7h1.7c.5 0 .7-.6.3-.9l-8.3-7.5a1 1 0 0 0-1.4 0L3 11.1c-.4.3-.2.9.3.9H5v7c0 .6.5 1 1 1h3c.6 0 1-.5 1-1z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "info"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 15a1 1 0 0 1-1-1v-4c0-.6.5-1 1-1s1 .5 1 1v4c0 .6-.5 1-1 1zm1-8h-2V7h2v2z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "language"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm7 6h-3c-.3-1.3-.8-2.5-1.4-3.6A8 8 0 0 1 18.9 8zm-7-4a14 14 0 0 1 2 4h-4a14 14 0 0 1 2-4zM4.3 14a8.2 8.2 0 0 1 0-4h3.3a16.5 16.5 0 0 0 0 4H4.3zm.8 2h3c.3 1.3.7 2.5 1.3 3.6A8 8 0 0 1 5.1 16zm3-8H5a8 8 0 0 1 4.3-3.6C8.8 5.5 8.4 6.7 8 8zM12 20a14 14 0 0 1-2-4h4a14 14 0 0 1-2 4zm2.3-6H9.7a14.7 14.7 0 0 1 0-4h4.6a14.6 14.6 0 0 1 0 4zm.3 5.6c.6-1.2 1-2.4 1.4-3.6h3a8 8 0 0 1-4.4 3.6zm1.8-5.6a16.5 16.5 0 0 0 0-4h3.3a8.2 8.2 0 0 1 0 4h-3.3z"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "leaderboard"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 21H3a1 1 0 0 1-1-1V10c0-.6.5-1 1-1h3.5c.6 0 1 .5 1 1v10c0 .6-.5 1-1 1zm7.3-18h-3.6a1 1 0 0 0-1 1v16c0 .6.5 1 1 1h3.6c.5 0 1-.5 1-1V4c0-.5-.5-1-1-1zm7.2 8h-3.5a1 1 0 0 0-1 1v8c0 .6.5 1 1 1H21c.6 0 1-.5 1-1v-8c0-.6-.4-1-1-1z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "lock"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 8h-1V6A5 5 0 0 0 7 6v2H6a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM9 8V6a3 3 0 1 1 6 0v2H9z"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "login"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.3 7.7a1 1 0 0 0 0 1.4l1.9 1.9H3a1 1 0 0 0-1 1c0 .6.5 1 1 1h9.2l-1.9 1.9a1 1 0 0 0 0 1.4c.4.4 1 .4 1.4 0l3.6-3.6c.4-.4.4-1 0-1.4l-3.6-3.6a1 1 0 0 0-1.4 0zM20 19h-7a1 1 0 0 0-1 1c0 .6.5 1 1 1h7a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-7a1 1 0 0 0-1 1c0 .6.5 1 1 1h7v14z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "logout"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5h6c.6 0 1-.5 1-1 0-.6-.5-1-1-1H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h6c.6 0 1-.5 1-1 0-.6-.5-1-1-1H5V5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6 11.7 18 8.9a.5.5 0 0 0-.9.3V11h-7a1 1 0 0 0-1 1c0 .6.5 1 1 1h7v1.8c0 .4.5.7.8.3l2.8-2.8c.2-.1.2-.5 0-.7z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "restore"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3 3A9 9 0 0 0 4 12H2.2c-.5 0-.7.5-.3.8l2.7 2.8c.2.2.6.2.8 0L8 12.8c.4-.3.1-.8-.3-.8H6a7 7 0 1 1 2.7 5.5 1 1 0 0 0-1.3.1 1 1 0 0 0 0 1.5A9 9 0 0 0 22 11.7C22 7 18 3.1 13.4 3zm-.6 5c-.4 0-.7.3-.7.8v3.6c0 .4.2.7.5.9l3.1 1.8c.4.2.8.1 1-.2.2-.4.1-.8-.2-1l-3-1.8V8.7c0-.4-.2-.7-.7-.7z"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "save"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 3.6a2 2 0 0 0-1.4-.6H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V7.8c0-.5-.2-1-.6-1.4l-2.8-2.8zM12 19a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm1-10H7c-1.1 0-2-.9-2-2s.9-2 2-2h6c1.1 0 2 .9 2 2s-.9 2-2 2z"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14h-.8l-.3-.3a6.5 6.5 0 1 0-.7.7l.3.3v.8l4.3 4.3a1 1 0 0 0 1.4-1.5L15.5 14zm-6 0a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "settings"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12v-.7l1.8-1.4c.4-.3.5-.9.3-1.3l-1.9-3.2a1 1 0 0 0-1.2-.4l-2.2.9-1.2-.7-.2-2.3a1 1 0 0 0-1-.9H10a1 1 0 0 0-1 .9l-.3 2.3-1.1.7-2.2-1a1 1 0 0 0-1.2.5L2.4 8.6a1 1 0 0 0 .3 1.3l1.8 1.4v1.4L2.7 14a1 1 0 0 0-.3 1.3l1.9 3.2c.2.5.8.6 1.2.4l2.2-.9 1.1.7.3 2.3c.1.5.5.9 1 .9H14c.5 0 .9-.4 1-.9l.2-2.3 1.2-.7 2.2 1c.4.1 1 0 1.2-.5l1.9-3.2c.2-.4.1-1-.3-1.3l-1.8-1.4V12zM12 15.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7z"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "text_fields"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.5C2.5 6.3 3.2 7 4 7h3.5v10.5a1.5 1.5 0 1 0 3 0V7H14a1.5 1.5 0 1 0 0-3H4c-.8 0-1.5.7-1.5 1.5zM20 9h-6a1.5 1.5 0 1 0 0 3h1.5v5.5a1.5 1.5 0 1 0 3 0V12H20a1.5 1.5 0 1 0 0-3z"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "visibility"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4C7 4 2.7 7.1 1 11.5a11.8 11.8 0 0 0 22 0C21.3 7.1 17 4 12 4zm0 12.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-8a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "visibility_off"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5a5 5 0 0 1 4.8 6.5l3 3c1.4-1.2 2.5-2.8 3.2-4.5a11.8 11.8 0 0 0-14.6-7l2.1 2.2 1.5-.2zM2.7 3.2a1 1 0 0 0 0 1.4l2 2c-1.6 1.2-3 3-3.7 4.9a11.8 11.8 0 0 0 15.3 6.7l2.7 2.7a1 1 0 1 0 1.4-1.4L4.1 3.2a1 1 0 0 0-1.4 0zM12 16.5a5 5 0 0 1-4.5-7.1L9 10.9l-.1.6a3 3 0 0 0 3.6 3L14 16c-.6.3-1.3.5-2.1.5zm3-5.3a3 3 0 0 0-2.7-2.7l2.7 2.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.5f02d872492e8396c690ac346349826c.svg";
export { ForwardRef as ReactComponent };